module.exports = __webpack_public_path__ + "img/bg3.35e29d20.png";